import type { ContactLookupByEmailMatchSchema } from '@liscio/api';

export type ContactSuggestionSource = 'existing_contact' | 'third_party_contact';

export type ContactSuggestion = ContactLookupByEmailMatchSchema;

export const isMeaningfulEmailQuery = (query: string): boolean => {
  const trimmedQuery = query.trim();
  return trimmedQuery.includes('@') || trimmedQuery.length >= 3;
};
